<template>
  <div class="rtl pages-navigator">
    <div class="flex-row arrows-container">
      <Icons
        icon="page-arrow-right"
        height="16px"
        width="16px"
        fill="black"
        v-tooltip="{
          content: this.$t('tooltip.firstPage'),
          placement: 'right',
        }"
        :class="{ disable: isFirstPage }"
        @click.stop="setPage(0)"
        @dblclick.stop
        class="cursor-pointer"
      />

      <div
        @click.stop="incPerek(-1)"
        @dblclick.stop
        class="flex-row"
        style="width: 19px; height: 12px; position: relative"
        v-tooltip="{
          content: this.$t('tooltip.prevPerek'),
          placement: 'right',
        }"
      >
        <Icons
          style="position: absolute; left: 0px; top: -2px"
          icon="page-arrow-right-1"
          height="16px"
          width="16px"
          fill="black"
          :class="{ disable: isFirstPerek }"
          class="cursor-pointer"
        />

        <Icons
          style="position: absolute; left: 6px; top: -2px"
          icon="page-arrow-right-1"
          height="16px"
          width="16px"
          fill="black"
          :class="{ disable: isFirstPerek }"
          class="cursor-pointer"
        />
      </div>
      <Icons
        icon="page-arrow-right-1"
        height="16px"
        width="16px"
        fill="black"
        v-tooltip="{
          content: this.$t('tooltip.prevPasuk'),
          placement: 'right',
        }"
        :class="{ disable: isFirstPage }"
        @click.stop="incPage(-1)"
        @dblclick.stop
        class="cursor-pointer"
      />

      <input
        ref="pageText"
        :value="page"
        @keydown.enter="goToPage"
        @input="goToPage"
        @wheel="wheeling"
        @focus="selectText($event.target)"
      />
      <span class="text">{{ $t("book.outof") }}</span>
      <span>&nbsp;</span>
      <span class="text">{{ numPages }}</span>

      <Icons
        v-tooltip="{
          content: this.$t('tooltip.nextPage1'),
          placement: 'right',
        }"
        icon="page-arrow-left"
        height="16px"
        width="16px"
        fill="black"
        :class="{ disable: isLastPage }"
        @click.stop="incPage(1)"
        @dblclick.stop
        class="cursor-pointer"
      />
      <!--  <div
      v-tooltip="{
        content: this.$t('tooltip.nextPage10'),
        placement: 'right',
      }"
      class="arrow-icon otz-icon"
      :class="{ disable: isLastPage }"
      @click.stop="incPage(10)"
      @dblclick.stop
    >
      4
    </div> -->
      <div
        @click.stop="incPerek(1)"
        @dblclick.stop
        class="flex-row"
        style="width: 19px; height: 12px; position: relative"
        v-tooltip="{
          content: this.$t('tooltip.nextPerek'),
          placement: 'right',
        }"
      >
        <Icons
          style="position: absolute; left: 0px; top: -2px"
          icon="page-arrow-left"
          height="16px"
          width="16px"
          fill="black"
          :class="{ disable: isLastPerek }"
          class="cursor-pointer"
        />

        <Icons
          style="position: absolute; left: 6px; top: -2px"
          icon="page-arrow-left"
          height="16px"
          width="16px"
          fill="black"
          :class="{ disable: isLastPerek }"
          class="cursor-pointer"
        />
      </div>
      <Icons
        v-tooltip="{ content: this.$t('tooltip.lastPage'), placement: 'right' }"
        icon="page-arrow-left-1"
        height="16px"
        width="16px"
        fill="black"
        :class="{ disable: isLastPage }"
        @click.stop="setPage(numPages)"
        @dblclick.stop
        class="cursor-pointer"
      />
    </div>
  </div>
</template>

<script>
let t;
import { mapActions } from "vuex";
import { goToPage as go } from "@/services/bookData.js";
import PagesPickerContainer from "./PagesPickerContainer.vue";
import Icons from "@/components/Icons/Icons.vue";
export default {
  props: ["numPages", "page", "tabId"],
  components: {
    PagesPickerContainer,
    Icons,
  },
  watch: {
    focusTxtSlector: function (val) {
      this.$refs.pageText.focus();
    },
  },
  computed: {
    focusTxtSlector: function (val) {
      return this.$store.state.tabsManager.focusPageSelector;
    },
    isFirstPage() {
      return this.$store.state.tabs[this.tabId].page == 1;
    },
    isLastPage() {
      return this.$store.state.tabs[this.tabId].page == this.numPages;
    },
    isLastPerek() {
      return this.page >= this.mainPages[this.mainPages.length - 1].id;
    },
    isFirstPerek() {
      return this.page < this.mainPages[1]?.id;
    },
    getPages() {
      return this.$store.state.tabs[this.tabId].pages;
    },
    mainPages() {
      return this.getPages.filter((page) => {
        try {
          return page.subId == 0;
        } catch (ex) {
          console.error(ex);
          return false;
        }
      });
    },
  },
  methods: {
    ...mapActions("tabsManager", ["incScrollTo"]),
    wheeling(event) {
      clearTimeout(t);
      t = setTimeout(() => {
        let numPages = event.wheelDeltaY / event.wheelDelta;
        if (event.wheelDelta > 0) numPages *= -1;
        this.incPage(numPages);
      }, 20);
    },
    goToPage(event) {
      try {
        let newPage = parseInt(event.srcElement.value);
        newPage = this.validatePage(newPage);
        go(newPage, this.tabId);
      } catch (ex) {
        console.error(ex);
      }
    },
    incPage(num) {
      try {
        let newPage = this.page + num;
        newPage = this.validatePage(newPage);
        go(newPage, this.tabId);
      } catch (ex) {
        console.error(ex);
      }
    },
    incPerek(direction) {
      try {
        let newPage = findClosestPositionIndex(
          this.page,
          this.mainPages,
          direction == 1
        );
        if (direction < 0) newPage--;
        if (newPage < 0) return;
        newPage = this.validatePage(this.mainPages[newPage].id);
        go(newPage, this.tabId);
      } catch (ex) {
        console.error(ex);
      }
    },
    setPage(num) {
      try {
        num = this.validatePage(num);
        go(num, this.tabId);
      } catch (ex) {
        console.error(ex);
      }
    },
    validatePage(page) {
      if (page < 1) page = 1;
      if (page > this.numPages) page = this.numPages;
      return page;
    },
    selectText(el) {
      el.select();
    },
  },
};

function findClosestPositionIndex(target, array, findGreater = true) {
  let left = 0;
  let right = array.length - 1;
  let result = -1; // Default to -1 if no appropriate position is found

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const midValue = array[mid].id;

    if (findGreater) {
      // If we're looking for the closest greater position
      if (midValue > target) {
        result = mid;
        right = mid - 1;
      } else {
        left = mid + 1;
      }
    } else {
      // If we're looking for the closest smaller position
      if (midValue <= target) {
        result = mid;
        left = mid + 1;
      } else {
        right = mid - 1;
      }
    }
  }

  return result;
}
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
.arrows-container {
  align-items: center;
  justify-content: center;
  padding-left: 5px;
}
.pages-navigator {
  margin: 0px 3px;
}

.arrow-icon {
  width: 17px;
  height: 100%;
  margin-right: 3px;

  &:hover:not(.disable) {
    background-color: transparent !important;
    color: #000;
  }
}
.text {
  height: 18px;
  line-height: 20px;
  font-size: 12px;
}
</style>
